import { styled } from 'styled-components';

export const StyledTab = styled.div`
  div[role='tab'] {
    padding: ${({ theme }) => theme.sizing.regular} 0;

    button > p,
    h4 {
      font-size: ${({ theme }) => theme.typography.bodyRegular.fontSize};
      margin: 0 ${({ theme }) => theme.sizing.small};
    }
  }
`;
StyledTab.displayName = 'StyledTab';

export const TileInlineLoader = styled.div`
  position: absolute;
  bottom: 0.625rem;
  left: 0.625rem;
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
`;
TileInlineLoader.displayName = 'TileInlineLoader';
